import React, { useRef } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Hero from "./Home/Hero"
import SolutionsSlider from "./Home/SolutionsSlider"
import InspirationSection from "./Home/InspirationSection"
import Testimonial from "./Home/Testimonial"
import "react-alice-carousel/lib/alice-carousel.css"
import "../../tailwind.css"

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <Hero />
      <SolutionsSlider />
      <InspirationSection />
      {/* <Testimonial /> */}
    </Layout>
  )
}

export default IndexPage
